import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import AddressIcon from '@/svg-icons/address';

const LocationReferencesSection = ({ locationReferences }) => {
  if (!locationReferences) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <AddressIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
        <FormattedMessage id="location_references" />
      </div>

      <div className="flex flex-col text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        {locationReferences.geo_link && (
          <div className="flex flex-col mb-[1vw]">
            <div className="font-bold">
              <FormattedMessage id="geo_link" />
            </div>
            <span className="block max-w-full overflow-hidden truncate">
              <a
                href={locationReferences.geo_link}
                target="_blank"
                rel="noreferrer noopener"
                data-cy="order-details-geo-link"
                className="hover:underline"
              >
                {locationReferences.geo_link}
              </a>
            </span>
          </div>
        )}

        {locationReferences.photo && (
          <div className="flex flex-col">
            <div className="font-bold">
              <FormattedMessage id="photo" />
            </div>
            <div className="flex mt-[0.2rem] max-w-[150px] max-h-[150px] border border-[#DEDEDE] p-1">
              <a href={locationReferences.photo} target="_blank" rel="noreferrer noopener">
                <img src={locationReferences.photo} alt="Foto da fachada" className="max-w-full max-h-full object-contain" />
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

LocationReferencesSection.propTypes = {
  locationReferences: PropTypes.object.isRequired,
};

export default LocationReferencesSection;
